import styled from 'styled-components';

const MainVisual = () => {
    return (
        <Wrap>
            <div className="con wh100per flex aic jcsb">
                <div className="text-box" data-aos="fade-right" data-aos-delay="300">
                    <h1 className='tb'>KEY-MINE,</h1>
                    <h2 className='tb'>언제 어디서나,<br/>내 손 안의 <span className="tb inblock">증명서</span></h2>
                    <p className='tm'>기업 및 단체에서 필요한 다양한 증명서를<br/>
                    통신3사 PASS앱을 통해 간편하게 발급 할 수 있습니다.</p>
                    <ul className='flex'>
                        <li className='rel'>
                            <span className="img-box abs xy-middle">
                                <img src="./img/ico_sk.png" alt="" />
                            </span>
                        </li>
                        <li className='rel'>
                            <span className="img-box abs xy-middle">
                                <img src="./img/ico_kt.png" alt="" />
                            </span>
                        </li>
                        <li className='rel'>
                            <span className="img-box abs xy-middle">
                                <img src="./img/ico_uplus.png" alt="" />
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="img-area">
                    <span className="img-box" data-aos="fade-left" data-aos-delay="700">
                        <img src="./img/main_visual_img_1.svg" alt="" />
                    </span>
                </div>
            </div>
        </Wrap>
    );
}

export default MainVisual;

const Wrap = styled.div`
    width: 100%;
    height: 895px;
    background: #fff;
    @media (max-width: 1400px) {
        height: 63.9285vw;
    }
    @media (max-width: 767px) {
        height: 585px;
        position: relative;
        .con {
            align-items: inherit;
            padding-top: 50px;
        }
    }

    .text-box {
        @media (max-width: 767px) {
            position: relative;
            z-index: 2;
            text-align: center;
        }

        > h1 {
            font-size: 36px;
            line-height: 48px;
            color: ${props => props.theme.mainColor1};
            @media (max-width: 1400px) {
                font-size: 2.5714vw;
                line-height: 3.4285vw;
            }
            @media (max-width: 767px) {
                font-size: 24px;
                line-height: 32px;
            }
        }

        > h2 {
            margin-top: 8px;
            font-size: 60px;
            line-height: 68px;
            color: #282828;
            @media (max-width: 1400px) {
                margin-top: 0.5714vw;
                font-size: 4.2857vw;
                line-height: 4.8571vw;
            }
            @media (max-width: 767px) {
                margin-top: 8px;
                font-size: 36px;
                line-height: 48px;
            }

            > span {
                line-height: 68px;
                color: ${props => props.theme.mainColor1};
                @media (max-width: 1400px) {
                    line-height: 4.8571vw;
                }
                @media (max-width: 767px) {
                    line-height: 48px;
                }
            }
        }

        > p {
            margin-top: 24px;
            font-size: 24px;
            line-height: 32px;
            color: #282828;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                font-size: 1.7142vw;
                line-height: 2.2857vw;
            }
            @media (max-width: 767px) {
                margin-top: 24px;
                font-size: 17px;
                line-height: 28px;
            }
        }

        > ul {
            margin-top: 40px;
            gap: 30px;
            @media (max-width: 1400px) {
                margin-top: 2.8571vw;
                gap: 2.1428vw;
            }
            @media (max-width: 767px) {
                margin-top: 40px;
                gap: 12px;
            }

            > li {
                width: 120px;
                height: 120px;
                background-color: #FAFAFA;
                border-radius: 12px;
                @media (max-width: 1400px) {
                    width: 8.5714vw;
                    height: 8.5714vw;
                    border-radius: 0.8571vw;
                }
                @media (max-width: 767px) {
                    width: calc(33.3333% - 8px);
                    height: auto;
                    padding-bottom: calc(33.3333% - 8px);
                    border-radius: 12px;
                    &:nth-child(1) > .img-box > img {
                        content: url(./img/ico_sk_mb.png);
                    }
                    &:nth-child(2) > .img-box > img {
                        content: url(./img/ico_kt_mb.png);
                    }
                    &:nth-child(3) > .img-box > img {
                        content: url(./img/ico_uplus_mb.png);
                    }
                }

                > .img-box {
                    width: 90px;
                    @media (max-width: 1400px) {
                        width: 6.4285vw;
                    }
                    @media (max-width: 767px) {
                        width: 80px;
                    }
                }
            }
        }
    }

    .img-area {
        width: 701px;
        margin-top: 26px;
        @media (max-width: 1400px) {
            width: 50.0714vw;
            margin-top: 1.8571vw;
        }
        @media (max-width: 767px) {
            width: 76.9230%;
            position: absolute;
            z-index: 1;
            left: 50%;
            transform: translateX(-50%);
            bottom: 38px;
        }
    }

`